import { useContext, useEffect } from "react";
import { AuthContext } from "context";
import dataFetcher from "hooks/bookService";
import formatErrorResponse from "helpers/form/formatErrorResponse";
import { BookingContext } from "../Context";
import { Role } from "types/user";
import { useNavigate, useParams } from "react-router";
import { ROUTES, buildRoute, RESERVATION_STEPS } from "routes";

const OurServicesBookingSetClient = () => {
    const { account } = useContext(AuthContext);
    const { getBooking, setBooking } = useContext(BookingContext);
    const navigate = useNavigate();
    const { id } = useParams();

    const isRecord = (value: unknown): value is Record<string, unknown> =>
        typeof value === "object" && value !== null;

    useEffect(() => {
        const updateBookSlot = async () => {
            if (account?.resources?.client[0].id) {
                const booking = Object.assign({}, getBooking(), {
                    client_id: account?.resources?.client[0].id,
                });

                try {
                    await dataFetcher.setClient(booking.id);
                    navigate(buildRoute.providerReservation(String(id), RESERVATION_STEPS.SUMMARY));
                    setBooking(booking);
                } catch (err: unknown) {
                    if (isRecord(err) && "response" in err && isRecord(err.response) && "data" in err.response) {
                        const responseData = err.response.data;
                        if (isRecord(responseData) && "data" in responseData) {
                            return formatErrorResponse(responseData as { data: unknown });
                        }
                    }
                    throw err;
                }
            }
        };

        if (account && !account.user.roles.includes(Role.CLIENT)) {
            navigate(ROUTES.HOME);
        }

        updateBookSlot();
    }, [account, getBooking, id, navigate, setBooking]);

    return <></>;
};

export default OurServicesBookingSetClient;
